const Radio = ({ label, isRequired, value = [], options, onChange = () => {} }) => {
  return (
    <>
      {label && (
        <label className="mmmbaa_label">
          {label}
          {isRequired ? <span className="required_star">*</span> : ""}
        </label>
      )}
      {Array.isArray(options) &&
        options.map((option, index) => {
          const val = option.label || option;
          return (
            <label key={index} className="input_checkbox_radio_item input_radio_item">
              {val}
              <input id={`input-ch-${index}`} type="radio" value={val} checked={val === value} onChange={() => onChange(val)} />
              <span className="checkmark"></span>
            </label>
          );
        })}
    </>
  );
};

export default Radio;
